interface Video {
  id: string;
  nom: string;
}
export const VideosEducatives: Video[] = [
  {
    id: '0acVyOiY71s',
    nom: 'Comment ouvrir un compte chez un intermédiaire en bourse',
  },
  {
    id: 'Wc9ROjF6WkI',
    nom: "Comment prévoir les cours boursiers grâce à l'analyse technique ?",
  },
  {
    id: 'xk3HtMEOzyg',
    nom: 'La bourse, un club de riches ?',
  },
  {
    id: 'kBotd7b-yWY',
    nom: 'Combien peut-on gagner à la Bourse de Tunis ?  (Partie 1)',
  },
  {
    id: 'Z7CQWSoOjSY',
    nom: 'Combien peut-on gagner à la Bourse de Tunis ?  (Partie 2)',
  },
  {
    id: 'PEbgoyTl5vQ',
    nom: "La différence entre l'investissement long terme et court terme",
  },
  {
    id: 'JJqeTuLejHE',
    nom: 'Les clés de la réussite à la Bourse de Tunis',
  },
  {
    id: 'q3MCmfdH--0',
    nom: 'Les gains des sociétés cotées à la Bourse de Tunis dévoilés',
  },
];
